import React, { useReducer, useState } from "react";
import "./style.css";
import Button from "@material-ui/core/Button";
import { FormButton, FormInput } from "../../../components/form";
import { useDispatch, useSelector } from "react-redux";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import { deleteSchool } from "../../../api/schools";
import { setAlert } from "../../../redux/reducers/alert";
import AddCircleIcon from "@material-ui/icons/AddCircle";

export const TableHeader = ({
  handleAdd,
  selectedIds,
  deleteCallback,
  searchValue,
}) => {
  const [{ search, searchError }, setData] = useReducer(
    (state, newState) => ({ ...state, ...newState }),
    {
      search: "",
      searchError: false,
    }
  );

  const [loading, setLoading] = useState(false);
  const { token } = useSelector((state) => state.user);
  const { role } = useSelector((state) => state.user);
  const dispatch = useDispatch();

  const handleChange = (prop) => (event) => {
    searchValue(event.target.value);
    setData({
      [prop]: event.target.value,
      searchError: false,
    });
  };

  const showErrorAlert = (message) => {
    dispatch(
      setAlert({
        severity: "error",
        message,
        show: true,
      })
    );
  };

  const handleDelete = async () => {
    try {
      setLoading(true);
      await Promise.all(
        selectedIds.map(async (id) => {
          await deleteSchool(id, token);
        })
      );

      deleteCallback();
      setLoading(false);
    } catch (err) {
      setLoading(false);
      showErrorAlert(
        err.message || "Error in deleting school. Please try again"
      );
    }
  };

  return (
    <div className="table-header  notifications-thead">
      <div style={{ width: 400 }}>
        {role === "manager" || role === "readOnly" ? (
          <FormInput
            disabled={true}
            error={searchError}
            value={search}
            onChange={handleChange}
            label={"Search by School Id or SchoolName"}
            name="search"
            height={35}
          />
        ) : (
          <FormInput
            error={searchError}
            value={search}
            onChange={handleChange}
            label={"Search by School Id or SchoolName"}
            name="search"
            height={35}
          />
        )}
      </div>

      <div style={{ flex: 1, display: "flex", justifyContent: "flex-end" }}>
        <div style={{ paddingLeft: 20 }}>
          {role === "manager" ? (
            <>
              <FormButton
                height={40}
                width={"10vw"}
                borderTopRightRadius={15}
                borderTopLeftRadius={15}
                borderBottomLeftRadius={15}
                borderBottomRightRadius={15}
                borderColor={"rgb(30,173,219)"}
                titleColor={"white"}
                hoverTitleColor={"white"}
                hoverBorderColor={"rgb(30,173,219)"}
                backgroundColor={"rgb(30,173,219)"}
                hoverBackgroundColor={"rgb(30,173,219)"}
                title={"Add School"}
                onClickHandler={handleAdd}
                startIcon={<AddCircleIcon />}
                disabled={true}
                overRideButtonCheck={true}
                style={{ fontSize: "0.8vw", fontWeight: "700" }}
              />
            </>
          ) : (
            <FormButton
              height={40}
              width={"10vw"}
              borderTopRightRadius={15}
              borderTopLeftRadius={15}
              borderBottomLeftRadius={15}
              borderBottomRightRadius={15}
              borderColor={"rgb(30,173,219)"}
              titleColor={"white"}
              hoverTitleColor={"white"}
              hoverBorderColor={"rgb(30,173,219)"}
              backgroundColor={"rgb(30,173,219)"}
              hoverBackgroundColor={"rgb(30,173,219)"}
              title={"Add School"}
              onClickHandler={handleAdd}
              startIcon={<AddCircleIcon />}
              style={{ fontSize: "0.8vw", fontWeight: "700" }}
            />
          )}
        </div>
      </div>
    </div>
  );
};
